import { createApp } from 'vue'
import { reflectiveInjectorPlugin, NullInjector, ReflectiveInjector } from '@tanbo/vue-di-plugin'

import App from './App.vue'
import router from './router'

// Http 服务的实现，请参考已有项目
import { Http, HttpConfig, HttpInterceptor } from '@zhfe/common-library'
import { API_URL } from '@/common/config'
import { HttpInterceptorService } from './services/http-interceptor.service'
import { CookieService } from './services/cookie.service';
import { ReportService } from './services/report.service';

const rootInjector = new ReflectiveInjector(new NullInjector(), [
  Http,
  CookieService,
  ReportService,
  {
    provide: HttpConfig,
    useValue: {
      baseURL: API_URL
    }
  },
  {
    provide: HttpInterceptor,
    useClass: HttpInterceptorService
  }
])
createApp(App)
  .use(reflectiveInjectorPlugin, rootInjector)
  .use(router)
  .mount('#app')
